import gql from 'graphql-tag';

export const AccessDetailsGroupCountsQuery = gql`
	query AccessDetailsGroupCountsQuery($groupIdList: [String]) {
		groupCounts(groupIds: $groupIdList) {
			groupCounts {
				key
				value
			}
		}
	}
`;
